import {Navigate} from "react-router-dom";

import {useStoredMe} from "@/src/modules/core/store/me";

import {routingService} from "../service";

export default function ManagementAdminNavGuard({children}: {children: React.ReactNode}) {
  const me = useStoredMe();

  if (!routingService.getCanAccessManagementAndAdminPanelNav(me)) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
}
